import React from "react";
import "./PaymentStatus.css";

const PendingPage = () => {
  return (
    <div className="payment-status-container payment-pending">
      <h2>⏳ Pago en Proceso</h2>
      <p>Tu pago está siendo procesado. Recibirás una confirmación cuando se complete.</p>
      <a href="/">Volver al inicio</a>
    </div>
  );
};

export default PendingPage;

